package com.merkost.handpass.api.dto.report

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ReportResponse(
    val id: String,
    @SerialName("listing_id") val listingId: String,
    @SerialName("reporter_id") val reporterId: String,
    val reason: String,
    val details: String? = null,
    val status: String = "pending",
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("listing_title") val listingTitle: String? = null,
    @SerialName("reporter_name") val reporterName: String? = null
)
